import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningLead() {
  return <section className="w-full px-6 py-16 md:py-20 bg-linen relative" data-id="element-123">
      <div className="max-w-3xl mx-auto text-center" data-id="element-124">
        <FadeIn data-id="element-125">
          <div className="space-y-10 text-xl md:text-2xl font-light leading-relaxed text-body" data-id="element-126">
            <p data-id="element-127">Hay un tipo de cansancio que no se arregla durmiendo.</p>
            <p data-id="element-128">Se arregla dejando de pelear contigo misma todas las noches.</p>
          </div>
        </FadeIn>

        <div className="my-10 h-px w-24 bg-rose/30 mx-auto" data-id="element-129"></div>

        <FadeIn delay={0.1} data-id="element-130">
          <div className="space-y-10 text-xl md:text-2xl font-light leading-relaxed text-body" data-id="element-131">
            <p data-id="element-132">Porque si eres honesta, tu día no es el problema.</p>
            <p data-id="element-133">
              El problema es ese punto… cuando ya terminaste con todo el mundo.
            </p>
            <p data-id="element-134">Cuando por fin hay silencio.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="my-14 relative" data-id="element-135">
          <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-8 text-6xl text-rose/10 font-serif" data-id="element-136">
            "
          </span>
          <p className="font-serif text-4xl md:text-5xl text-charcoal italic leading-tight px-4" data-id="element-137">
            Y tu cerebro dice: <br data-id="element-138" />
            <span className="text-rose" data-id="element-139">Ahora me toca a mí.</span>
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-140">
          <div className="space-y-6 text-lg md:text-xl font-light text-body/80" data-id="element-141">
            <p data-id="element-142">Ahí aparece la cocina. El pan. Lo dulce. Lo salado.</p>
            <p data-id="element-143">Lo que sea que te haga sentir algo distinto por 10 minutos.</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="mt-10 mb-14" data-id="element-144">
          <p className="text-lg md:text-xl font-light leading-relaxed" data-id="element-145">
            Y al día siguiente vuelves a lo mismo: ropa apretada, panza
            inflamada, promesa de lunes, culpa que no te ayuda.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-146">
          <div className="relative py-10 px-8 border-y border-charcoal/10 bg-white/40 backdrop-blur-sm" data-id="element-147">
            <p className="font-serif text-2xl md:text-3xl text-charcoal leading-snug" data-id="element-148">
              No necesitas otra dieta.
              <br data-id="element-149" />
              <span className="italic text-rose" data-id="element-150">
                Necesitas una estructura que proteja tu noche.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}